import { defineMessages } from '@jutro/locale';

export default defineMessages({
    additionalDetailsHeader: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Additional Details',
        defaultMessage: 'Additional Details'
    },
    verifyingVins: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Verifying VINs',
        defaultMessage: 'Verifying VIN\'s'
    },
    vehicleX: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.vehicleX',
        defaultMessage: '(Vehicle #{vehicleNumber})'
    },
    driverX: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.driverX',
        defaultMessage: '(Driver #{driverNumber})'
    },
    excludedDriverX: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.excludedDriverX',
        defaultMessage: '(Excluded Driver #{driverNumber})'
    },
    vinDesc: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.vinDesc',
        defaultMessage: 'VIN required. Must be 17 digits if 1981 and newer.'
    },
    serialNumber: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    vehOwnedFinancedLeased: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Is this vehicle owned, financed or leased',
        defaultMessage: 'Is this vehicle owned, financed or leased?'
    },
    driverLicense: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Driver License',
        defaultMessage: 'Driver\'s License'
    },
    stateLicensed: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.State Licensed',
        defaultMessage: 'State Licensed'
    },
    ageFirstLicensed: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    financialResponsibilityProof: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.financialResponsibilityProof',
        defaultMessage: 'Requires proof of financial responsibility (SR22/FR44/FR19/FS1)?'
    },
    requiresProofTooltipTitle: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.requiresProofTooltipTitle',
        defaultMessage: 'What is an SR22/FR44/FR19/FS1?'
    },
    requiresProofTooltip: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.requiresProofTooltip',
        defaultMessage: 'Proof of Financial Responsibility is a state-mandated document that certifies that the liability insurance purchased meets the minimum required limits of coverage for the state. The certificate (SR22, FR44, FR19 or FS1) is filed with your state\'s Department of Motor Vehicles by your auto insurance carrier. Select this if you have a Proof of Financial Responsibility certification with your current carrier or if your state\'s DMV or a court order requires you to have the certification. We do not charge a fee to file the certificate.'
    },
    stateRequesting: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.State Requesting',
        defaultMessage: 'Which state is requiring Proof?'
    },
    reasonRequired: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Reason Required',
        defaultMessage: 'Reason Required'
    },
    certEffDate: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Certificate Effective Date',
        defaultMessage: 'Certificate Effective Date'
    },
    caseNumber: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Case Number',
        defaultMessage: 'Case Number'
    },
    emailAddress: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Email Address',
        defaultMessage: 'Email Address'
    },
    spouseEmailAddress: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.Spouse\'s Email Address',
        defaultMessage: 'Spouse\'s Email Address'
    },
    reviewAdditionalActivity: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.review for any additional activity',
        defaultMessage: 'review for any additional activity'
    },
    mvrsMayBeRun: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.MVRs may be run',
        defaultMessage: 'MVRs may be run'
    },
    nextDesc: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.nextDesc',
        defaultMessage: 'We\'ll {reviewAdditionalActivity} next and {mvrsMayBeRun}'
    },
    removeLeaseLoanGap: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.removeLeaseLoanGap',
        defaultMessage: 'Unable to change from Financed as vehicle includes Lease Loan Gap coverage. Remove Lease Loan Gap coverage to continue.'
    },
    updateFieldOrAddInterestedParty: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.updateFieldOrAddInterestedParty',
        defaultMessage: 'Please update Owned/Financed/Leased field or add Interested Party Information.'
    },
    updateOwnedFinanceLeasedField: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.updateOwnedFinanceLeasedField',
        defaultMessage: 'Please update Owned/Financed/Leased field as Interested Party Information was added.'
    },
    licenseStateHelpTitle: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.licenseState.helpTextTitle',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    licenseStateHelpText: {
        id: 'ml.gateway.policyChange.pa.additionalInfoToPurchase.licenseState.helpText',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
    invalidEmail:{
        id:'ml.gateway.policyChange.pa.additionalInfoToPurchase.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    duplicateLicenseError:{
        id:'ml.gateway.policyChange.pa.additionalInfoToPurchase.License numbers must be unique',
        defaultMessage:"License numbers must be unique."
    },
    missingAnnualMileage: {
        id: 'ml.gatewayquoteandbind.pa.additionalInformation.missingAnnualMileage',
        defaultMessage: 'Annual Mileage is required for this vehicle. Please navigate to the Vehicle Information screen to enter Annual Mileage before proceeding.'
    }
});
